export default {
    indexOccupationSettings:  { method: 'get',    url: 'occupation_settings' },
    showOccupationSettings:   { method: 'get',    url: 'occupation_settings/{id}' },
    createOccupationSettings: { method: 'post',   url: 'occupation_settings' },
    updateOccupationSettings: { method: 'put',    url: 'occupation_settings/{id}' },
}
